import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../vuex/store'
import {
  ROUTE_AFFILIATE,
  // ROUTE_REGISTER_BANK_INFO,
  ROUTE_CASHBACK,
  ROUTE_COMMISSION,
  ROUTE_CONTACT,
  ROUTE_CREDIT,
  ROUTE_DEPOSIT,
  ROUTE_EXTERNAL_CASINO,
  ROUTE_EXTERNAL_FOOTBALL,
  ROUTE_EXTERNAL_SLOT,
  ROUTE_INTERNAL_LOTTO,
  ROUTE_GAME_LOTTO_DETAIL,
  ROUTE_INDEX,
  ROUTE_LIST,
  // ROUTE_LOGIN,
  ROUTE_RULE,
  // ROUTE_PAYRATE,
  ROUTE_GAME_OTHERS,
  ROUTE_NEWS,
  // ROUTE_NOTFOUND,
  // ROUTE_OTP,
  // ROUTE_REGISTER_ID_USER_INFO,
  // ROUTE_REGISTER_ID_BANK_INFO,
  // ROUTE_REGISTER_ID_PERSONAL_INFO,
  // ROUTE_DEMO_REGISTER_PERSONAL_INFO,
  // ROUTE_DEMO_REGISTER_USER_INFO,
  // ROUTE_DEMO_REGISTER_BANK_INFO,
  // ROUTE_RESET_PASSWORD,
  ROUTE_RESULT,
  ROUTE_SETTING,
  ROUTE_STATUS,
  ROUTE_TEMPLATE_NUMBER,
  ROUTE_TRASACTION,
  // ROUTE_REGISTER_USER_INFO,
  ROUTE_VOUCHER,
  ROUTE_WITHDRAW,
  ROUTE_POWER_BALL,
  ROUTE_V3_PAYRATE,
  ROUTE_V3_LOGIN,
  ROUTE_V3_REGISTER,
  ROUTE_V3_FORGOT_PASSWORD,
  // ROUTE_LANDING_PAGE,
  ROUTE_GAME_TYPE,
  ROUTE_RESULT_DETAIL
} from '../const/route'
import { validateVersion } from '../const/version'

// import EmptyLayout from '@/layout/empty-layout.vue'
import LoginV3 from '@/views-v3/Login'
import PayrateV3 from '@/views-v3/Payrate'
import RegisterV3 from '@/views-v3/Register'
import ForgotPasswordV3 from '@/views-v3/ForgotPassword'

import HomepageV3 from '@/views-v3/Homepage'
import GameTypeV3 from '@/views-v3/GameType'

import LayoutV2 from '@/layout/default-after-login-v2.vue'
import Lotto from '@/views/Lotto'
import LottoOnline from '@/views/Lotto/LottoOnline'
import LottoForm from '@/views-v3/Lotto/LottoForm'
import PowerBall from '@/views-v2/PowerBall'
import Vouchers from '@/views/Vouchers'
import Deposit from '@/views/Deposit'
import Commission from '@/views/Commission'
import Withdraw from '@/views/Withdraw'
import Setting from '@/views/Setting'
import ListBet from '@/views-v2/ListBet'
import Affiliate from '@/views/Affiliate'
import Prize from '@/views-v2/Prize'
import PrizeDetail from '@/views-v2/Prize/Detail'
import CreditReport from '@/views/CreditReport'
import TemplateNumber from '@/views/TemplateNumber'
import Casino from '@/views/ExternalGame/Casino.vue'
import Football from '@/views/ExternalGame/Football.vue'
import Slot from '@/views/ExternalGame/Slot.vue'
import GameOthers from '@/views/ExternalGame/GameOthers.vue'
import ContactAgent from '@/views/ContactAgent.vue'
import News from '@/views/News.vue'
import Cashback2 from '@/views/Cashback2'
import Status from '@/views/Status'
import TransactionReport from '@/views/TransactionReport'
// import LayoutLoginV2 from '@/layout/default-before-login-v2.vue'
// import LayoutLoginV1 from '@/layout/default-before-login-v1.vue'
// import Login from '@/views-v2/Login'
import Rule from '@/views-v2/Rule'
// import Payrate from '@/views-v2/Payrate'


Vue.use(VueRouter)

// const PATH_FILE = 'views-v2'
const version = 'v2'
// const PATH_FILE_V3 = 'views-v3'

const routes = [
  // {
  //   path: '/v3',
  //   component: () => import(`@/layout/empty-layout.vue`),
  //   children: [

  //   ]
  // },
  // {
  //   path: '/l',
  //   component: () => import(`@/layout/empty-layout.vue`),
  //   children: [
  //     {
  //       path: '',
  //       name: ROUTE_LANDING_PAGE,
  //       component: () => import(`@/views-v3/Index`),
  //       meta: {
  //         requireLogin: false
  //       },
  //     },
  //   ]
  // },
  {
    path: '/login',
    component: () => import(`@/layout/empty-layout.vue`),
    children: [
      {
        path: '',
        name: ROUTE_V3_LOGIN,
        component: LoginV3,
        meta: {
          requireLogin: false
        },
      },
    ]
  },
  {
    path: '/payrate',
    component: () => import(`@/layout/empty-layout.vue`),
    children: [
      {
        path: '',
        name: ROUTE_V3_PAYRATE,
        component: PayrateV3,
        meta: {
          requireLogin: false
        },
      },
    ]
  },
  {
    path: '/register',
    component: () => import(`@/layout/empty-layout.vue`),
    children: [
      {
        path: '',
        name: ROUTE_V3_REGISTER,
        component: RegisterV3,
        meta: {
          requireLogin: false
        },
      },
    ]
  },
  {
    path: '/forgot-password',
    component: () => import(`@/layout/empty-layout.vue`),
    children: [
      {
        path: '',
        name: ROUTE_V3_FORGOT_PASSWORD,
        component: ForgotPasswordV3,
        meta: {
          requireLogin: false
        },
      }
    ]
  },
  {
    path: '/',
    component: LayoutV2,
    children: [
      {
        path: '',
        name: ROUTE_INDEX,
        meta: {
          requireLogin: true
        },
        component: HomepageV3,
      },
      {
        path: 'game-types',
        name: ROUTE_GAME_TYPE,
        meta: {
          requireLogin: true
        },
        component: GameTypeV3,
      },
      {
        path: 'lotto',
        component: Lotto,
        meta: {
          requireLogin: true
        },
        children: [
          {
            path: '',
            name: ROUTE_INTERNAL_LOTTO,
            component: LottoOnline,
            meta: {
              requireLogin: true
            }
          },
          {
            path: 'select',
            name: ROUTE_GAME_LOTTO_DETAIL,
            component: LottoForm,
            meta : {
              requireLogin:true
            } 
          }, 
        ]
      },
      {
        path: 'power-ball',
        name: ROUTE_POWER_BALL,
        component: PowerBall,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'vouchers',
        name: ROUTE_VOUCHER,
        component: Vouchers,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'deposit',
        name: ROUTE_DEPOSIT,
        component: Deposit,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'commission',
        name: ROUTE_COMMISSION,
        component: Commission,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'withdraw',
        name: ROUTE_WITHDRAW,
        component: Withdraw,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'setting',
        name: ROUTE_SETTING,
        component: Setting,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'list',
        name: ROUTE_LIST,
        component: ListBet,
        meta : {
          requireLogin:true
        }
      },
      {
        path: 'referal',
        name: ROUTE_AFFILIATE,
        component: Affiliate,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'result',
        name: ROUTE_RESULT,
        component: Prize,
        meta : {
          requireLogin:true
        }
      },
      {
        path: 'result/:id',
        name: ROUTE_RESULT_DETAIL,
        component: PrizeDetail,
        meta : {
          requireLogin:true
        }
      },
      {
        path: 'credit',
        name: ROUTE_CREDIT,
        component: CreditReport,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'numberset',
        name: ROUTE_TEMPLATE_NUMBER,
        component: TemplateNumber,
        meta: {
          requireLogin: true
        }
      },

      {
        path: 'casino',
        name: ROUTE_EXTERNAL_CASINO,
        component: Casino,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'football',
        name: ROUTE_EXTERNAL_FOOTBALL,
        component: Football,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'slot',
        name: ROUTE_EXTERNAL_SLOT,
        component: Slot,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'game-others',
        name: ROUTE_GAME_OTHERS,
        component: GameOthers,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'contact',
        name: ROUTE_CONTACT,
        component: ContactAgent,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'news',
        name: ROUTE_NEWS,
        component: News,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'cashback-v2',
        name: ROUTE_CASHBACK,
        component: Cashback2,
        meta : {
          requireLogin:true
        }
      },
      {
        path: 'status',
        name: ROUTE_STATUS,
        component: Status,
        meta: {
          requireLogin: true
        }
      },
      {
        path: 'transactions',
        name: ROUTE_TRASACTION,
        component: TransactionReport,
        meta: {
          requireLogin: true
        }
      },
    ]
  },
  {
    path: '*',
    redirect: { name: ROUTE_INDEX }
  },
  // {
  //   path: '/v1/login',
  //   component: LayoutLoginV2,
  //   children: [
  //     {
  //       path: '',
  //       name: ROUTE_LOGIN,
  //       component: Login,
  //       meta: {
  //         requireLogin: false
  //       }
  //     },
  //   ]
  // },
  {
    path: '/rules',
    component: () => import(`@/layout/empty-layout.vue`),
    children: [
      {
        path: '',
        name: ROUTE_RULE,
        component: Rule,
        meta : {
          requireLogin: false
        }
      },
    ]
  },
  // {
  //   path: '/payrate',
  //   component: LayoutLoginV2,
  //   children: [
  //     {
  //       path: '',
  //       name: ROUTE_PAYRATE,
  //       component: Payrate,
  //       meta : {
  //         requireLogin: false
  //       }
  //     },
  //   ]
  // },
  // {
  //   path: '/recap',
  //   component: () => import(`@/views/RecaptchaTest.vue`),

  // },
  // {
  //   path: '/resetpassword',
  //   component: LayoutLoginV1,
  //   children: [
  //     {
  //       path: '',
  //       name: ROUTE_RESET_PASSWORD,
  //       component: () => import('@/views/ChangePassword/index.vue'),
  //       meta: {
  //         requireLogin: false
  //       }
  //     },
  //   ]
  // },
  // {
  //   path: '/v1/register',
  //   component: () => import(`@/layout/default-before-login-v1.vue`),
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/Register'),
  //       children: [
  //         {
  //           path: '',
  //           name: ROUTE_OTP,
  //           component: () => import('@/views/Register/OTP'),
  //         },
  //         {
  //           path: 'info',
  //           component: () => import('@/views/Register/Form'),
  //           children: [
  //             {
  //               path: '',
  //               name: ROUTE_REGISTER_USER_INFO,
  //               component: () => import('@/views/Register/Form/childs/userInfo.vue'),
  //             },
  //             {
  //               path: 'bank',
  //               name: ROUTE_REGISTER_BANK_INFO,
  //               component: () => import('@/views/Register/Form/childs/bankInfo.vue'),
  //             },
  //           ]
  //         },
  //       ]
  //     },
  //   ]
  // },
  // {
  //   path: '/demo-register',
  //   component: () => import(`@/layout/default-before-login-v1.vue`),
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/DemoRegister'),
  //       children: [
  //         {
  //           path: '',
  //           name: 'ROUTE_OTP',
  //           component: () => import('@/views/DemoRegister/OTP'),
  //         },
  //         {
  //           path: 'demo-info',
  //           component: () => import('@/views/DemoRegister/Form'),
  //           children: [
  //             {
  //               path: '',
  //               name: ROUTE_DEMO_REGISTER_PERSONAL_INFO,
  //               component: () => import('@/views/DemoRegister/Form/childs/information.vue'),
  //             },
  //             {
  //               path: 'demo-id',
  //               name: ROUTE_DEMO_REGISTER_USER_INFO,
  //               component: () => import('@/views/DemoRegister/Form/childs/userInfo.vue'),
  //             },
  //             {
  //               path: 'demo-bank',
  //               name: ROUTE_DEMO_REGISTER_BANK_INFO,
  //               component: () => import('@/views/DemoRegister/Form/childs/bankInfo.vue'),
  //             },
  //           ]
  //         },
  //       ]
  //     },
  //   ]
  // },
  // {
  //   path: '/register/:userUuid/users',
  //   component: () => import(`@/layout/default-before-login-v1.vue`),
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/Register/_id'),
  //       children: [
  //         {
  //           path: '',
  //           name: ROUTE_REGISTER_ID_PERSONAL_INFO,
  //           component: () => import('@/views/Register/_id/childs/personal-info'),
  //         },
  //         {
  //           path: 'auth',
  //           name: ROUTE_REGISTER_ID_USER_INFO,
  //           component: () => import('@/views/Register/_id/childs/username-password.vue'),
  //         },
  //         {
  //           path: 'bank',
  //           name: ROUTE_REGISTER_ID_BANK_INFO,
  //           component: () => import('@/views/Register/_id/childs/bank-account.vue'),
  //         }
  //       ]
  //     },
  //   ]
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, _, next) => {

  // const isLineBrowser = navigator.userAgent.includes('Line/')

  // if (isLineBrowser && !to.query.openExternalBrowser) {
  //   // rebuild URL with ?openExternalBrowser=1
  //   const separator = to.fullPath.includes('?') ? '&' : '?';
  //   const redirectUrl = `${window.location.origin}${to.fullPath}${separator}openExternalBrowser=1`;

  //   window.location.replace(redirectUrl);
  //   return;
  // }

  // for login from bo
  if (to.query.token) {
    //middle ware set only state
    store.commit('auth/MUTATION_TOKEN', to.query.token)

    //middleware login
    localStorage.setItem('access-Token', to.query.token)
    next({
      name: ROUTE_INDEX,
    })
    return
  }

  //check if route require login must logined
  if (to.meta.requireLogin && !store.getters['auth/GETTERS_TOKEN']) {
    to.matched[0].components.default = () => import(`@/views-v3/HomepageLogin.vue`);
    next();
    // next({
    //   name: ROUTE_V3_LOGIN,
    // });
    return
  } else if (!to.meta.requireLogin && store.getters['auth/GETTERS_TOKEN']) {
    next({
      name: ROUTE_INDEX
    });
  }

  //add query param for not found
  if (!to.query.v && to.name === ROUTE_INDEX) {
    next({
      name: to.name,
      query: { v: version }
    });
    return
  }
  //get version and set to localstorage and sync it
  if (to.query.v && to.query.v !== version && to.name === ROUTE_INDEX) {
    //set version
    const setItem = validateVersion(to.query.v)
    localStorage.setItem('version', setItem)
    if (setItem !== version) {
      //reload for fetch version
      window.location = window.location.pathname;
      // location.reload()
    } else {
      next({
        name: to.name,
        query: { v: setItem }
      });
    }
    return
  }

  next();
})

router.afterEach((to) => {
  const base = window.location.origin

  if (to.name === ROUTE_V3_LOGIN) {
    let link = document.querySelector("link[rel='canonical']")
    if (!link) {
      link = document.createElement("link")
      link.setAttribute("rel", "canonical")
      document.head.appendChild(link)
    }
    link.setAttribute("href", `${base}/`)
  }
})

export default router
